module.exports = __webpack_public_path__ + "img/hz_28.df755d13.jpg";